import { createFeatureSelector, createSelector } from '@ngrx/store';

export interface SalesRepState {
  loading: boolean;
}

export const getSalesRepState = createFeatureSelector<SalesRepState>('salesRep');

export const getSalesRepLoading = createSelector(getSalesRepState, state => state.loading);
